import { render, staticRenderFns } from "./FormComplete.vue?vue&type=template&id=2236d21a&scoped=true&"
import script from "./FormComplete.vue?vue&type=script&lang=js&"
export * from "./FormComplete.vue?vue&type=script&lang=js&"
import style0 from "./FormComplete.vue?vue&type=style&index=0&id=2236d21a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2236d21a",
  null
  
)

export default component.exports